
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { shortDate, } from '~/utils/filters/shortDate.filter';
import { isDate, } from '~/utils/models/isObject';

@Component
export default class DateDisplay extends Vue {

	@Prop({
		type: Date,
		required: true,
	})
	date!: Date;

	get isValidDate() {
		return isDate(this.date);
	}

	shortDate = shortDate;
}
